import React, { Component } from 'react';
import { Col, Row, FormGroup, Input, Label, ModalBody, ModalFooter } from 'reactstrap';
import { Dialog } from '@material-ui/core';
import closeIcon from '@iconify/icons-ion/md-close';
import * as XLSX from 'xlsx';
import { FormattedMessage } from 'react-intl';
import { Icon } from '@iconify/react';
import Dropzone from 'react-dropzone';
import moment from 'utils/moment';
import style from './importExcel.module.scss';
import Modal from '../../../../components/modal';
import Loading from '../../../../components/loading';
import Button from '../../../../components/button/button';
import { GetFileName, S3Uploads } from '../../../services';

class ImportExcel extends Component {
    constructor(props) {
      super(props);
      this.state = {
        excelHeaders: [],
        mappedFields: {},
        staticFields: [],
        requiredFieldError: false,
        emptyCells: [],
        formatError: {},
        fieldsForValidation: {},
        columnErrList: {},
        loading: false
      };
    }

componentDidMount() {
  const { fieldsForMapping } = this.props;
  const reqiredCustomFields = fieldsForMapping.filter(field => field.required)?.map(field => field.id);
  const customFields = {};
  if (fieldsForMapping?.length > 0) {
    fieldsForMapping.forEach((field) => {
      customFields[field.id] = field;
    });
    this.setState({
      staticFields: [...fieldsForMapping],
      customFields,
      requiredFields: [...reqiredCustomFields]
    });
  }
}

handleMappedFields = (id, value) => {
  this.setState(prevState => ({
    mappedFields: {
      ...prevState.mappedFields,
      [id]: value
    }
  }));
}

handleUploadAttachments = async (attachments, entity) => {
  const attachmentIds = [];
  const newAttachments = [];
  const oldAttachments = [];
  attachments.forEach((e) => {
    if (!e.id) {
      newAttachments.push(e);
    } else if (e.id && e.name) {
      oldAttachments.push(e);
    }
  });
  let fileIds = '';
  if (newAttachments.length > 0) {
    fileIds = await GetFileName.getUploadFileName(newAttachments?.length);
  }
  if (fileIds) {
    await S3Uploads.uploadFiles(
      newAttachments,
      fileIds.filename,
      entity || 'avp',
      false
    ).then(() => {
      fileIds.filename.forEach((id) => {
        attachmentIds.push(id.toString());
      });
    });
  }
  if (oldAttachments.length > 0) {
    attachmentIds.push(...oldAttachments);
  }
  return attachmentIds;
}

handleFile = async (answer) => {
  const { toggleUploadModal, sourceComponent, fieldsForMapping } = this.props;
  const { mappedFields } = this.state;
  if (answer?.length > 0) {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: 'binary' });

        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];

        const range = XLSX.utils.decode_range(ws['!ref']);
        const excelData = [];

        const headers = [];
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const cell_address = { c: C, r: range.s.r };
          const cell_ref = XLSX.utils.encode_cell(cell_address);
          const header = ws[cell_ref] && (ws[cell_ref].w || ws[cell_ref].v);
          if (header) headers.push(header.toUpperCase());
        }
        if (headers.length > 0) {
          let R = range.s.r + 1;
          for (R; R <= range.e.r; R++) {
              const row_list = {};
              for (let C = range.s.c; C <= range.e.c; C++) {
                  const cell_address = { c: C, r: R };
                  const cell_ref = XLSX.utils.encode_cell(cell_address);
                  if (ws[cell_ref]?.w || ws[cell_ref]?.v) row_list[headers[C]] = ws[cell_ref]?.w || ws[cell_ref]?.v;
              }
              if (Object.keys(row_list).length > 0) excelData.push(row_list);
          }
        }
        const fieldsToMoveLast = ['Company', "Applicant's First Name", "Applicant's Last Name", "Applicant's Phone Number"];
        let tempMappedFields = {};
        let dateFields = [];
        let phoneFields = [];
        let numberFields = [];
        if (sourceComponent === 'avp') {
          fieldsForMapping.forEach((field) => {
            let value = field.title.toUpperCase();
              if ((field.required || fieldsToMoveLast.includes(field.title))) {
                value = `*${field.title.toUpperCase()}`;
              }
            if (field.type === 'datetime' || field.type === 'date') {
              dateFields.push(value);
            }
            if (field.type === 'telephone') {
              phoneFields.push(value);
            }
            if (field.type === 'number') {
              numberFields.push(value);
            }
            if (headers.includes(value)) {
               tempMappedFields[value] = field.id;
            }
          });
        }
        this.setState({ excelHeaders: headers,
          excelData,
          mappedFields: { ...mappedFields, ...tempMappedFields },
          fieldsForValidation: { dateFields, phoneFields, numberFields } });
      };
      reader.readAsBinaryString(answer[0]);
      toggleUploadModal('save');
    }
  };

  formatDate = (dateString, getYear) => {
    const date = new Date(dateString);
    if (`${date}` === 'Invalid Date') {
      return `${date}`;
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    if (getYear) {
      return `${year}`;
    }
    return `${year}-${month}-${day}`;
}

handleExcelData = async () => {
  const { excelData, mappedFields, customFields, requiredFields, fieldsForValidation } = this.state;
  const { form, toggleExcelModal, sourceComponent } = this.props;
  const response = { 'form_data': [] };
  let noErrors = true;
  let requireMapFields = [];
  let uniqueError = false;
  let requiredFieldError = false;
  let requiredDataError = false;
  let dateErr = false;
  let phoneErr = false;
  let dateList = [];
  let phoneList = [];
  let numList = [];
  let numErr = false;
  const emptyCells = [];
  const uniqueValues = new Set(Object.values(mappedFields));
  const validateRequredFields = requiredFields?.every(req => Array.from(uniqueValues).includes(req));
    requiredFields.forEach(req => Object.keys(mappedFields).forEach((field) => {
      if (mappedFields[field] === req) {
        requireMapFields.push(field);
      }
    }));
    if (uniqueValues.size !== Object.values(mappedFields).length) {
      noErrors = false;
      uniqueError = true;
    } else if (!validateRequredFields) {
          requiredFieldError = true;
          noErrors = false;
    } else {
      excelData.forEach((excelRow) => {
        requireMapFields.forEach((mapField) => {
          if (excelRow[mapField] === undefined && !emptyCells.includes(mapField)) {
            emptyCells.push(mapField);
            requiredDataError = true;
            noErrors = false;
          }
        });
        if (sourceComponent === 'avp') {
        if (fieldsForValidation?.dateFields) {
          fieldsForValidation.dateFields.forEach((mapField) => {
            if (excelRow[mapField] !== '' && this.formatDate(excelRow[mapField]) === 'Invalid Date') {
              if (dateList.findIndex(i => i === mapField) === -1) dateList.push(mapField);
              dateErr = true;
              noErrors = false;
            }
          });
        }
        if (fieldsForValidation?.phoneFields) {
          const invalidChars = /[^0-9+]/;
          fieldsForValidation.phoneFields.forEach((mapField) => {
            if (excelRow[mapField] !== '' && invalidChars.test(excelRow[mapField])) {
              if (phoneList.findIndex(i => i === mapField) === -1) phoneList.push(mapField);
              phoneErr = true;
              noErrors = false;
            }
          });
        }
        if (fieldsForValidation?.numberFields) {
          fieldsForValidation.numberFields.forEach((mapField) => {
            if (excelRow[mapField] !== '' && (Number.isNaN(Number(excelRow[mapField])))) {
              if (numList.findIndex(i => i === mapField) === -1) numList.push(mapField);
              numErr = true;
              noErrors = false;
            }
          });
        }
      }
      });
    }
  if (noErrors) {
    const data = [];
    excelData.forEach((excelRow) => {
    const row = {};
    const custom_data = {};
    Object.keys(excelRow).forEach((mapField) => {
      if (mappedFields[mapField]) {
        if (customFields[mappedFields[mapField]]) {
          if (customFields[mappedFields[mapField]].type === 'select') {
            const selectedValue = customFields[mappedFields[mapField]].values.filter(option => option.value === excelRow[mapField]);
            if (selectedValue.length > 0) custom_data[mappedFields[mapField]] = selectedValue[0]?.key;
          } else if (customFields[mappedFields[mapField]].type === 'multiselect') {
            // eslint-disable-next-line no-param-reassign
            excelRow[mapField] = excelRow[mapField]?.split(', ');
            const selectedValue = customFields[mappedFields[mapField]].values.filter(option => excelRow[mapField].indexOf(option.value) !== -1);
            if (selectedValue.length > 0) custom_data[mappedFields[mapField]] = selectedValue.map(value => value.key);
          } else if (customFields[mappedFields[mapField]].type === 'date' || customFields[mappedFields[mapField]].type === 'datetime') {
            custom_data[mappedFields[mapField]] = sourceComponent === 'avp'
            ? this.formatDate(excelRow[mapField], mappedFields[mapField] === 'year_of_reg')
            : moment(String(excelRow[mapField]), 'DD/MM/YY').utc().format();
          } else if (customFields[mappedFields[mapField]].type === 'time') {
            custom_data[mappedFields[mapField]] = moment(excelRow[mapField], 'HH:mm').utc().format();
          } else {
            custom_data[mappedFields[mapField]] = excelRow[mapField];
          }
        }
      }
    });
    data.push(custom_data);
    row.response = custom_data;
    response.parent = form?.id;
    response.form_data.push(row);
  });
  if (sourceComponent === 'avp') {
    this.setState({ loading: true });
    toggleExcelModal(data);
  }
  } else {
    this.setState({ requiredFieldError,
      uniqueError,
      requiredDataError,
      emptyCells,
      formatError: { dateErr, phoneErr, numErr },
      columnErrList: { dateList, phoneList, numList } });
  }
}

render() {
  const { toggleUploadModal, uploadModal, excelModal, toggleExcelModal, downloadCSVTemplate,
  fieldsForMapping } = this.props;
  const { excelHeaders, mappedFields, staticFields, requiredFields, requiredFieldError, uniqueError, requiredDataError, emptyCells,
  formatError, columnErrList, loading } = this.state;
  const reqFieldsList = fieldsForMapping?.filter(req => requiredFields
    ?.filter(field => (req.required === true && field === req.id && !Object.values(mappedFields || {}).includes(field)))?.length > 0)
    ?.map(err => err.title);

  return (
      <div>
        <Loading loadingStatus={loading} />
        {uploadModal
        && <Modal showIn={uploadModal} onClose={() => toggleUploadModal()} width="554px" minHeight="25%">
                <div className={style.modalHeader}>
                  <div className={style.modalTitle}>
                    <FormattedMessage
                      id="documents.upload.file.title"
                      defaultMessage="Upload file"
                    />
                  </div>
                  <div className={style.iconGroup}>
                    <Icon
                      icon={closeIcon}
                      onClick={() => toggleUploadModal()}
                      height="20"
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                </div>
                <ModalBody className="text-center">
                    {downloadCSVTemplate && (
                      <div onClick={() => downloadCSVTemplate()} onKeyPress={() => downloadCSVTemplate()} role="button" tabIndex={0}
                      style={{ cursor: 'pointer', color: '#4183c4' }}>
                        <FormattedMessage id="gate.list.table.action" defaultMessage="Download Template" />
                      </div>
                    )}
                    <Dropzone
                      onDrop={this.handleFile}
                      disableClick
                      className={style.dropzone}
                      accept={'.xlr,.xls,.xlsx,.csv,.ods'}
                      multiple={false}
                    >
                      {({ open }) => (
                          <p className={style.browsetext}>
                            <FormattedMessage
                              id="gate.logo.text1"
                              defaultMessage="Drag an excel file here or"
                            />
                            <button type="button" onClick={() => open()}>
                              <FormattedMessage
                                id="gate.logo.button"
                                defaultMessage=" browse "
                              />
                            </button>
                            <FormattedMessage
                              id="gate.logo.text2"
                              defaultMessage="for a file to upload."
                            />
                          </p>
                      )}
                    </Dropzone>
                </ModalBody>
           </Modal>
        }
        {excelModal && !uploadModal && excelHeaders?.length > 0
        && <Row>
          <Dialog scroll="paper" open={excelModal} onClose={() => toggleExcelModal()}>
            <div className={style.modalHeader}>
              <div className={style.modalTitle}>
                <FormattedMessage
                  id="documents.upload.file.mapping"
                  defaultMessage="Excel Data Mapping"
                />
              </div>
              <div className={style.iconGroup}>
                <Icon
                  icon={closeIcon}
                  onClick={() => toggleExcelModal()}
                  height="20"
                  style={{ cursor: 'pointer' }}
                />
              </div>
            </div>
            <ModalBody className={`text-center ${style.importModalStyle}`}>
              {excelHeaders.length > 0 && (
                  <Col sm="12" md="12" className="padding">
                      <form onSubmit={this.handleUpload}>
                        {excelHeaders.map(header => (
                            <FormGroup row>
                              <Label for="exampleEmail" md={6}>{header}</Label>
                              <Col sm={5} md={5}>
                                <Input type="select" name="Select Field" id="mappedFields"
                                  value={mappedFields[header]}
                                  onChange={e => this.handleMappedFields(header, e.target.value)}
                                >
                                  <option value={undefined} id={header} />
                                  {staticFields.map(assetField => (
                                    <option value={assetField.id} id={assetField.id}>{assetField.title}</option>
                                  ))}
                                </Input>
                              </Col>
                            </FormGroup>
                        ))}
                        {requiredFieldError && (
                          <p style={{ color: 'red' }}>
                            <FormattedMessage
                              id="import.form.data.required.fields.error"
                              defaultMessage="Please select all the following required Fields:"
                            />
                            {reqFieldsList?.map(field => (<>{`  ${field}${reqFieldsList.length > 1 ? ',' : ''} `}</>))}
                          </p>
                        )}
                        {uniqueError && (
                          <p style={{ color: 'red' }}>
                            <FormattedMessage
                              id="import.form.data.multiple.fields.error."
                              defaultMessage="Some fields have been selected more than once."
                            />
                          </p>
                        )}
                        {requiredDataError && (
                          <p style={{ color: 'red' }}>
                            <FormattedMessage
                              id="import.form.data.required.fields.value.error"
                              defaultMessage="Required fields must contain the value:"
                            />
                            {emptyCells.map(cell => (<>{`  ${cell}${emptyCells.length > 1 ? ',' : ''} `}</>))}
                          </p>
                        )}
                        {formatError.dateErr && (
                          <p style={{ color: 'red' }}>
                            <FormattedMessage
                              id="import.form.data.required.fields.value.error."
                              defaultMessage="Invalid date formats detected.
                              Please verify and correct the date entries in the following columns:"
                            />
                            {columnErrList?.dateList?.map(cell => (<>{`  ${cell}${columnErrList?.dateList.length > 1 ? ',' : ''} `}</>))}
                          </p>
                        )}
                        {formatError.phoneErr && (
                          <p style={{ color: 'red' }}>
                            <FormattedMessage
                              id="import.form.data.required.fields.value.error."
                              defaultMessage="Phone number contains invalid characters.
                              Please verify and correct the phone number entries in the following columns:"
                            />
                            {columnErrList?.phoneList?.map(cell => (<>{`  ${cell}${columnErrList?.phoneList.length > 1 ? ',' : ''} `}</>))}
                          </p>
                        )}
                         {formatError.numErr && (
                          <p style={{ color: 'red' }}>
                            <FormattedMessage
                              id="import.form.data.required.fields.value.error."
                              defaultMessage="Invalid number formats detected.
                                Please verify and correct the numeric entries in the following columns:"
                            />
                            {columnErrList?.numList?.map(cell => (<>{`  ${cell}${columnErrList?.numList.length > 1 ? ',' : ''} `}</>))}
                          </p>
                        )}
                      </form>
                  </Col>
              )}
            </ModalBody>
            <ModalFooter>
              <div className={style.footerButtons}>
                <span style={{ marginRight: '20px' }}>
                  <Button action="teritary" translationID="gate.new.addBtn"
                    defaultText="Cancel" onClick={() => toggleExcelModal()}
                  />
                </span>
                <span>
                  <Button action="secondary" translationID="gate.new.addBtn"
                    defaultText="Save"
                    onClick={this.handleExcelData}
                  />
                </span>
              </div>
            </ModalFooter>
          </Dialog>
           </Row>
        }
      </div>
);
}
}


export default ImportExcel;
